<template>
  <div class="page-wrapper">
    <v-container fluid class="mb-10" :class="{'fill-height': isBasketEmpty}">
      <v-row v-if="loading">
        <v-col cols="12" class="text-center my-10">
          <v-progress-circular
            indeterminate
            color="primary"/>
        </v-col>
        <v-col cols="12" class="text-center my-10" v-if="loadingMessage !== null && loadingMessage.length > 0" v-html="loadingMessage">
<!--          {{}}-->
        </v-col>
      </v-row>
      <v-row v-else-if="isBasketEmpty" align="center" justify="center">
        <v-col class="text-center">
          <v-icon x-large>fas fa-shopping-cart</v-icon><br><br>
          <span> Your basket is empty.</span>
        </v-col>
      </v-row>
      <v-list v-else>
        <v-list-group v-for="vendor of vendorList" :key="vendor.id" v-if="baskets[vendor.id].list.length > 0">
          <template v-slot:activator >
            <v-list-item-title>{{vendor.title}} ({{baskets[vendor.id].list.length}})  <span v-if="baskets[vendor.id].deliveryDate != undefined" style="float:right;">{{baskets[vendor.id].deliveryDate}}</span></v-list-item-title>
          </template>
          <v-card v-for="(order, index) in baskets[vendor.id].list" :key="index" class="my-2" outlined>
            <v-card-text class="pb-0 pt-0">
              <v-row>
                <v-col cols="10" class="pa-2">
                  <div class="h6">{{order.title}}</div>
                </v-col>

                <v-col cols="2" class="pa-2 text-right">
                  <div class="h6"><v-icon style="color:red;" @click="deleteItem(index, vendor.id)">fas fa-trash</v-icon></div>
                </v-col>

              </v-row>
              <v-row>
                <v-col cols="3" class="text-center py-0">
                  <v-btn fab small @click="onItemAmountChanged(index,-1, vendor.id)" v-bind:color="'error'" >
                    <v-icon size="20px">fas fa-minus</v-icon>
                  </v-btn>
                </v-col>
                <v-col cols="6" class="ma-0">
                  <v-text-field class="ma-0 pa-0 centered-input " type="number" hide-details
                                single-line v-model="order.amount"/>
                  <!--          <div class="h4 text-center">{{amount}}</div>-->
                </v-col>
                <v-col cols="3" class="text-center py-0">
                  <v-btn fab small @click="onItemAmountChanged(index,1, vendor.id)"  v-bind:color="'primary'" >
                    <v-icon size="20px" >fas fa-plus</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
              <v-row v-if="vendor.id == 0">
                <v-col class="pb-0">
                  <v-textarea @change="saveBasket(vendor.id)" rows="2" filled outlined label="MEMO" v-model="order.note"/>
                </v-col>
              </v-row>
            </v-card-text>
<!--            <div class="price text-right mb-3 mr-3">-->
<!--              £{{(order.totalPrice/100).toFixed(2)}}-->
<!--            </div>-->
          </v-card>
          <v-row>
            <v-col class="py-0">
              <v-row>
                <v-col class="pb-0">
                  <v-textarea auto-grow outlined
                              label="ORDER MEMO"
                              placeholder="EMPTY"
                              rows="2"
                              v-model="baskets[vendor.id].note"

                              @change="saveBasket(vendor.id)"/>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="4" class="text-center">
                  <v-icon style="color:red;" @click="deleteItem(-100, vendor.id)">fas fa-trash</v-icon>
                  <br>
                  Clear
                </v-col>
                <v-col cols="8" class="text-right">
                  <div v-if="vendor.id == 0" style="font-weight: bold; color:black; font-size: 1.2rem;">
                    Delivery Date:
                    <br/>
                    {{baskets[vendor.id].deliveryDate}}
                  </div>
                  <div v-else style="font-weight: bold; color:black; font-size: 1.2rem;" v-on:click="chooseOrderDate(vendor.id)">
                    Vendor Delivery Date:
                    <br/>
                    {{baskets[vendor.id].deliveryDate}}
<!--                    <date-picker v-model="baskets[vendor.id].deliveryDate" valueType="format" @input="saveBasket(vendor.id)"></date-picker>-->
<!--                    <input type="date"  style="border:1px solid black; min-height: 30px;"/>-->
                  </div>
                </v-col>
<!--                <v-col cols="6" class="text-right pt-0">-->
<!--                  Sub total £{{(baskets[vendor.id].totalPrice/100).toFixed(2)}}<br>-->
<!--                  VAT £{{(baskets[vendor.id].tax/100).toFixed(2)}}<br>-->
<!--                  Due £{{(baskets[vendor.id].finalDue/100).toFixed(2)}}-->
<!--                </v-col>-->
              </v-row>
              <v-row>
                <v-col class="pb-0">
                  <v-btn block color="primary" v-if="vendor.id > 0 || canSubmitToKokoro === true"
                         @click="submitOrder(vendor.id)">
                    PLACE ORDER
                  </v-btn>
                  <div v-if="vendor.id === 0 && canSubmitToKokoro === false" style="color: red; font-weight: bold;">
                    {{noOrderMessage}}
                  </div>
                </v-col>
              </v-row>
            </v-col>

          </v-row>
          <br/>
          <br/>
        </v-list-group>
      </v-list>
    </v-container>
    <v-dialog v-model="deleteDialog">
      <v-card>
        <v-card-title>
          Remove Item
        </v-card-title>
        <v-card-subtitle style="padding-top:20px;">
          {{deleteDialogMessage}}
        </v-card-subtitle>
        <v-card-actions>
          <v-spacer/>
          <v-btn color="green darken-1" text @click="cancelDeleteItem">Cancel</v-btn>
          <v-btn color="green darken-1" text @click="deleteItemConfirmed">Remove</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="showDatePicker">
      <v-date-picker
        v-model="dateToChoose"
        />
      <v-btn v-on:click="selectDate">
        <span>SELECT</span>
      </v-btn>
    </v-dialog>
  </div>
</template>

<script>
  import DatePicker from 'vue2-datepicker';
  import 'vue2-datepicker/index.css';
  import {
    checkCanSubmitOrder,
    clearBasket,
    getNextDeliveryDateFromServer,
    loadBasket,
    placeOrder,
    saveBasket
  } from "../api/order";
  import {getDeliveryDates, getVendorList, placeVendorOrder, sendVendorOrder} from "../api/vendor";
  import {getDateString, millisToDate, showDialog, getWeAppVersion} from "../api/utils";
  import EventBus from "../api/event-bus";

  export default {
    name: "Basket",
    data(){
      return {
        loading: true,
        loadingMessage:'',
        isBasketEmpty: true,

        vendorList: [
          {
            id: 0,
            title: 'KOKORO',
          }
        ],
        baskets: {
          0: loadBasket()
        },
        format: 'YYYY-MM-DD',
        deleteDialog: false,
        deleteDialogMessage:'',
        deleteVendorId:-1,
        deleteIndex:-1,
        // today: new Date(),
        deliveryDates: new Array(7),
        orderDate: false,
        showDatePicker: false,
        dateToChoose: '',
        canSubmitToKokoro:true,
        noOrderMessage:'',
        webAppVersion:getWeAppVersion(),
      }
    },
    components: {
      DatePicker
    },
    created() {
      console.log("created");
      this.getVendorList()
      this.correctDeliveryDate();
      this.checkIfCanSubmit(false);
    },
    mounted() {
      console.log("mounted");
    },
    methods: {
      getVendorList: function() {
        let vm = this

        // console.log("get vendor list check localstorage " + localStorage.getItem("vendor_list"));
        if(localStorage.getItem("vendor_list") != null) {
          vm.vendorList = JSON.parse(localStorage.getItem("vendor_list"));
          console.log("vl " + vm.vendorList.length);
          console.log(vm.vendorList);
          if(vm.vendorList.length > 0) {
            for(let i = 0 ; i < vm.vendorList.length ; i++) {
              vm.baskets[vm.vendorList[i].id] = loadBasket(vm.vendorList[i].id)
              // if(vendor.id > 0) {
              //   if (vm.baskets[vendor.id].deliveryDate == undefined || vm.baskets[vendor.id].deliveryDate === '') {
              //     vm.baskets[vendor.id].deliveryDate = new Date();
              //   }
              // } else {
              if (vm.baskets[vm.vendorList[i].id].deliveryDate == undefined) {
                vm.baskets[vm.vendorList[i].id].deliveryDate = getDateString(new Date(), 1);

                // }
              }
            }
            vm.loading = false;
            vm.loadingMessage = "";
            vm.updateBasketEmpty(vm);
            return;
          }
        }
        // vm.loading = true
        getVendorList()
          .then(data => {
            console.log(data)

            for(let vendor of data.item) {
              vm.vendorList.push(vendor)

              vm.baskets[vendor.id] = loadBasket(vendor.id)
              // if(vendor.id > 0) {
              //   if (vm.baskets[vendor.id].deliveryDate == undefined || vm.baskets[vendor.id].deliveryDate === '') {
              //     vm.baskets[vendor.id].deliveryDate = new Date();
              //   }
              // } else {
                if (vm.baskets[vendor.id].deliveryDate == undefined) {
                  vm.baskets[vendor.id].deliveryDate = getDateString(new Date(), 1);

                // }
              }

            }

            vm.loading = false;
            vm.loadingMessage = "";
          })
        .finally(() => vm.updateBasketEmpty(vm))
      },
      updateBasketEmpty: function(){
        this.isBasketEmpty = true

        for(const [_, basket] of Object.entries(this.baskets))
          this.isBasketEmpty = this.isBasketEmpty && (basket.list.length === 0)
      },

      saveBasket: function(vendorId){
        console.log("save basket");
        // console.log(this.baskets[vendorId]);
        saveBasket(
          this.baskets[vendorId],
          vendorId
        );
      },
      cancelDeleteItem: function() {
        this.$data.deleteIndex = -1;
        this.$data.deleteVendorId = -1;
        this.$data.deleteDialogMessage = "";
        this.$data.deleteDialog = false;
      },
      getVendorName: function(vendorId) {
        if(vendorId == 0) {
          return 'KOKORO';
        }
        for(let i = 0 ; i < this.$data.vendorList.length ; i++) {
          if(this.$data.vendorList[i].id == vendorId) {
            return this.$data.vendorList[i].title;
          }
        }
        return vendorId;
      },
      deleteItem: function(index, vendorId = 0) {
        this.$data.deleteIndex = index;
        this.$data.deleteVendorId = vendorId;
        if(index >= 0) {
          this.$data.deleteDialogMessage = "Remove " + this.baskets[vendorId].list[index].title + "?";
        } else {
          this.$data.deleteDialogMessage = "Empty Basket for " + this.getVendorName(vendorId) + "?";
        }
        this.$data.deleteDialog = true;

      },
      deleteItemConfirmed: function() {
        // EventBus.$emit('onBasket', -1)

        if(this.$data.deleteIndex < 0 && this.$data.deleteVendorId < 0) {
          this.cancelDeleteItem();
          return;
        }
        if(this.$data.deleteIndex < 0) {
          this.baskets[this.$data.deleteVendorId].list = [];
          clearBasket(this.$data.deleteVendorId);

        } else {
          this.baskets[this.$data.deleteVendorId].list.splice(this.$data.deleteIndex, 1);
        }
        this.updateBasketEmpty()
        this.updateTotalPrice(this.$data.deleteVendorId);
        this.cancelDeleteItem();

      },
      onItemAmountChanged: function(index, diff, vendorId = 0) {
        let basket = this.baskets[vendorId]

        let amount = parseInt(basket.list[index].amount)

        if(amount + diff <= 0) {
          this.deleteItem(index, vendorId);
          return;
        }
        basket.list[index].amount = amount + diff;
        if(basket.list[index].amount <= 0) {
          basket.list.splice(index, 1);
        } else {
          basket.list[index].totalPrice = basket.list[index].amount * basket.list[index].price;
          basket.list[index].tax = basket.list[index].totalPrice * basket.list[index].taxRate/10000;
          basket.list[index].finalDue = basket.list[index].totalPrice + basket.list[index].tax;
        }

        this.updateTotalPrice(vendorId);

      },
      updateTotalPrice: function(vendorId = 0) {
        this.loading = true
        this.loadingMessage = "Updating prices";
        let totalPrice = 0;
        let totalTax = 0;

        let orderList = this.baskets[vendorId].list
        for(let order of orderList) {
          totalPrice += order.totalPrice;
          totalTax += order.tax;
        }

        this.baskets[vendorId].tax = totalTax;
        this.baskets[vendorId].totalPrice = totalPrice;
        this.baskets[vendorId].finalDue = totalPrice + totalTax;

        this.saveBasket(vendorId);
        this.loading = false
        EventBus.$emit('onBasket', -1)
        EventBus.$emit('onBasketChanged');
      },
      kokoroOrder: function(order){
        let vm = this

        vm.loading = true
        vm.loadingMessage = "Generating order";
        if(order.note != null && order.note.length > 0) {
          order.notes = [
            {
              id:0,
              description:order.note,

            }
          ]
        }

        for(let i = 0 ; i < order.list.length ; i++) {
          if(order.list[i].note != null && order.list[i].note.length > 0) {
            order.list[i].notes = [
              {
                id:0,
                description: order.list[i].note,
              }
            ]
            order.list[i].note = "";
          }
          order.list[i].orderedAmount = order.list[i].amount;
        }

        if(this.$data.webAppVersion !== undefined && this.$data.webAppVersion !== null && this.$data.webAppVersion.length > 0) {
          order.version = this.$data.webAppVersion;
        } else {
          order.version = "old";
        }

        placeOrder(order)
        .then(function(data) {
          if(data.success) {
            console.log("Order Submitted", data.item)
            EventBus.$emit('onBasket', -order.list.length)

            let msg = "Order Submitted";
            if(data.message != null && data.message.length > 0) {
              msg += "<br/>" + data.message;
            }
            showDialog(msg + `<br>Delivery Date: ${order.deliveryDate}`, )

            vm.baskets[0] = {list: []}
            clearBasket(0);
            EventBus.$emit('onBasket', -1)
            EventBus.$emit('onBasketChanged');
            vm.loading = false
          } else {
            showDialog(data.message, "Order Place Failed")
          }
        })
        .catch(function(err) {
          console.log(err)
          let msg = err;
          if(err.response != undefined) {
            msg += ' (' + err.response + ')';
          }
          showDialog("Please capture screen and send to administrator. Error: " + msg, "ERROR");
        })
      },
      vendorOrder: function(order, vendorId){
        let vm = this

        vm.loading = true
        vm.loadingMessage = 'Generating Order';
        if(order.note != null && order.note.length > 0) {
          order.notes = [
            {
              id:0,
              description:order.note,

            }
          ]
        }

        for(let i = 0 ; i < order.list.length ; i++) {
          if(order.list[i].note != null && order.list[i].note.length > 0) {
            order.list[i].notes = [
              {
                id:0,
                description: order.list[i].note,
              }
            ]
            order.list[i].note = "";
          }
        }

        placeVendorOrder(order)
          .then(function(data) {
            console.log(data);
            if(data.success) {
              console.log("Order Submitted", data.item)
              EventBus.$emit('onBasket', -order.list.length)

              // showDialog(`Delivery Date: ${order.deliveryDate}`, "Order Submitted")

              vm.baskets[vendorId] = {list: []}
              clearBasket(vendorId);
              EventBus.$emit('onBasket', -1)
              vm.loading = false
              vm.sendVendorOrder(data.item.id, 0);
              EventBus.$emit('onBasketChanged');
            } else {
              showDialog(data.message);
            }
          })
          .catch(function(err) {
            console.log(err)
            let msg = err;
            if(err.response != undefined) {
              msg += ' (' + err.response + ')';
            }
            showDialog("Please capture screen and send to administrator. Error: " + msg, "ERROR");

          })
      },
      sendVendorOrder: function(id, count, message = '') {
        let vm = this
        if(count >= 5) {
          showDialog('<span style="color:red; font-weight: bold;">Failed to send order.</span><br/>Reason: ' + message + '<br/>This order can be found on "Orders Page". You can try submission again', "ERROR");
          vm.loading = false;
          return;
        }
        vm.loading = true;
        let dialogmessage = 'Sending Order to vendor';
        if(count >= 1) {
          dialogmessage += "<br/>Attempt: " + count + "/5";
        }
        vm.loadingMessage = dialogmessage;
        sendVendorOrder(id)
          .then(function(data) {
            if(data.success) {
              console.log("Order Submitted", data.item)

              showDialog('', "Order Submitted Successfully")

              vm.loading = false
            } else {
              console.log("Error at sending order");
              // vm.loading = false
              vm.sendVendorOrder(id, count+1, data.message);
              // showDialog(data.message);
            }
          })
          .catch(function(err) {
            vm.loading = false
            console.log(err)
            if(err.response !== undefined) {
              console.log(err.response);
            }
          })
      },
      submitOrder: function(vendorId) {
        let order = this.baskets[vendorId]



        if(vendorId === 0) {
          // order.deliveryDate = this.getCloseDate()
          // console.log(order);
          this.checkBeforeSubmitToKokoro(order);
        } else {

          if(order.deliveryDate === '' || order.deliveryDate === '0000-00-00') {
            showDialog("Please choose delivery date");
            return;
          }
          let today = millisToDate(new Date().getTime(), '-');

          if(order.deliveryDate <= today) {
            showDialog("The earliest delivery date is tomorrow");
            return;
          }
          this.vendorOrder(order, vendorId)
        }
      },
      checkBeforeSubmitToKokoro: function(order) {
        let self = this;
        checkCanSubmitOrder()
          .then(function(data) {
            self.$data.canSubmitToKokoro = data.success;
            self.$data.noOrderMessage = data.message;
            if(data.success === true) {
              if(order.deliveryDate !== data.message) {
                order.deliveryDate = data.message;
                showDialog("Next delivery date is changed now to " + order.deliveryDate + ". Please check and click place order again");
                return;

                // Show dialog. process if user presses confirmation

              } else {
                self.kokoroOrder(order);
              }
            } else if(data.success === false) {
              showDialog(data.message, "SORRY");
            }
          })
          .catch(function(err) {
            console.log(err);
            if(err.response !== undefined) {
              console.log(err.response);
            }
          })
      },
      checkIfCanSubmit: function(showDialog = false) {
        let self = this;
        console.log("check if can submit now");
        checkCanSubmitOrder()
        .then(function(data) {
          console.log("check if can submit response");
          console.log(data);
          self.$data.canSubmitToKokoro = data.success;
          self.$data.noOrderMessage = data.message;
          if(data.success === false && showDialog) {
            showDialog(data.message, "SORRY");
          }
        })
        .catch(function(err) {
          console.log(err);
          if(err.response !== undefined) {
            console.log(err.response);
          }
        })
      },
      getDeliveryDates: function () {
        let vm = this
        getDeliveryDates()
        .then((data) => {
          // console.log(data.item)
          if(data.success == true) {
            vm.deliveryDates = data.item;
            vm.correctDeliveryDate();
          }
        })
      },
      chooseOrderDate: function(vendorId) {
        console.log("select date for " + vendorId);
        console.log(this.$data.baskets);

        this.$data.orderDate = JSON.parse(JSON.stringify(this.$data.baskets[vendorId]));
        this.$data.dateToChoose = getDateString(new Date(), 1)
        this.$data.orderDate.vendorIndex = vendorId;
        this.$data.showDatePicker = true;
        console.log("select date set for " + this.$data.orderDate.vendorIndex );
      },
      selectDate: function() {
        console.log(this.$data.orderDate)
        console.log("date selected for " + this.$data.orderDate.vendorIndex);
        this.$data.baskets[this.$data.orderDate.vendorIndex].deliveryDate = this.$data.dateToChoose;
        this.saveBasket(this.$data.orderDate.vendorIndex)

        this.$data.orderDate = false;
        this.$data.showDatePicker = false;
      },
      correctDeliveryDate: function() {
        let self = this;
        getNextDeliveryDateFromServer()
          .then(function(data) {
            if(data.success === true) {
              self.baskets[0].deliveryDate = data.message;
            } else {
              showDialog(data.message);
            }
          })
          .catch(function(err) {
            showDialog("Cannot get next delivery date", "ERROR");
          })

      },
      getCloseDate: function () {

        // console.log(this.deliveryDates);
        let today = new Date();
        // console.log(today.getDay());

        let dayOfTheWeek = today.getDay();

        let closestDate = false;
        let deliveryDay = false;
        for(let i = 0 ; i < this.deliveryDates.length ; i++) {
          if(this.deliveryDates[i].selected == false) {
            continue;
          }
          let cutOffDayDiff =  this.deliveryDates[i].cutOffDay - dayOfTheWeek;
          let delDayDiff = this.deliveryDates[i].deliveryDay - dayOfTheWeek;
          if(cutOffDayDiff < 0) {
            cutOffDayDiff += 7;
            delDayDiff += 7;
          }
          let targetDate = new Date();
          let deliveryDate = new Date();
          deliveryDate.setHours(12, 0, 0, 0);
          targetDate.setDate(today.getDate() + cutOffDayDiff);
          deliveryDate.setDate(today.getDate() + delDayDiff);
          // console.log(targetDate);
          // targetDate.setHours(this.deliveryDates[i].cutOffTimeHour);
          // targetDate.setMinutes(0);
          // targetDate.setSeconds(0);
          // targetDate.setMilliseconds(0);

          targetDate.setHours(23);
          targetDate.setMinutes(59);
          targetDate.setSeconds(59);
          targetDate.setMilliseconds(999);
          if(targetDate < today) {
            targetDate.setDate(targetDate.getDate() + 7);
            deliveryDate.setDate(targetDate.getDate() + 7);
          }
          // console.log("Cut off date time");
          // console.log(targetDate);
          let diff = targetDate - today;
          // console.log(diff);
          if(closestDate == false || closestDate > targetDate) {
            closestDate = targetDate;
            deliveryDay = deliveryDate;
          }
        }

        // console.log("Closest date is ");
        // console.log(closestDate);
        // console.log(deliveryDay);
        return deliveryDay.toISOString().split('T')[0]
        // 오늘을 포함한 일주일 탐색
        // console.log("Day of week " + dayOfTheWeek);
        // for(let i=0; i<7; i++){
        //   // 오늘부터 일주일간의 요일 인덱스
        //   let index = (dayOfTheWeek + i) % 7
        //
        //   // 배송 가능한 날짜 탐색
        //   if(this.deliveryDates[index] !== undefined && this.deliveryDates[index].selected) {
        //     let isNextWeek = (dayOfTheWeek + i >= 7)
        //     // 주문 가능 기한 날짜 확인
        //     if (isNextWeek || dayOfTheWeek <= this.deliveryDates[index].cutOffDay) {
        //       // 오늘 일자를 기준으로 일수 증가
        //       console.log("Delivery Date " + i);
        //       console.log(this.deliveryDates[index]);
        //       let deliveryDate = new Date()
        //       deliveryDate.setDate(today.getDate() + i)
        //       console.log("Found")
        //       console.log(deliveryDate);
        //
        //       // 문자열 변환
        //       return deliveryDate.toISOString().split('T')[0]
        //     }
        //   }
        // }
      },

    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Basket.vue